import { FC, useMemo } from "react";

import UpTokenCoin from "../../../../../assets/icons/upTokenCoin.svg";

interface Props {
    playerWithMostUpper: any[];
}

const UserImageAndUpScore: FC<Props> = ({ playerWithMostUpper }) => {

    const sortedPlayers = useMemo(() => {
        if ( playerWithMostUpper.length < 3) {
            const topTwo = playerWithMostUpper.slice(0, 2);
            return [topTwo[1], topTwo[0]];
        } else {
            const topThree = playerWithMostUpper.slice(0, 3);
            return [topThree[1], topThree[0], topThree[2]];
        }
        
    }, [playerWithMostUpper]);

    const getColor = (player: any): string => {
        if (player.color === "blue")
            return "#3AC1CC";
        if (player.color === "yellow")
            return "#FFD200";
        if (player.color === "green")
            return "#51BD8A"
        if (player.color === "pink")
            return "#EB078A"

        return "#EB078A";
    }

    return (
        <div className="image_score_container">
            {sortedPlayers.map( (player: any, index: number) => (
                <div key={index} className="player_image_Score_wrapper center_vertically">
                    <img style={{ border: `4px solid ${getColor(player)}` }} className="player_image" src={`${process.env.REACT_APP_BACKEND_URL}images/${player.email}.png`} alt="" />
                    <p className="mini_profile_text_style">{player.nickName}</p>
                    <img className="up_icon_token" src={UpTokenCoin} alt="" />
                    <p className="mini_profile_text_style">{player.upper}</p>
                </div>
            ))}       
        </div>
    )
};

export default UserImageAndUpScore;